import { Switch, Text, VStack } from '@montel/montelpro-shared-components-v2';
import { FC } from 'react';
import styled from 'styled-components';

const SwitchInput: FC<{
	label: string;
	onChange: (checked: boolean) => void;
	isChecked: boolean;
}> = ({ label, onChange, isChecked }) => (
	<InputWrapper gap="lg">
		<Text color="textSubtle">{label}</Text>
		<Switch
			isChecked={isChecked}
			onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
				const checked = e.target.checked;
				onChange(checked);
			}}
		/>
	</InputWrapper>
);

const InputWrapper = styled(VStack)`
	padding-top: 2px;
	position: relative;
	width: fit-content;
	align-self: stretch;
	white-space: nowrap;
	height: 100%;
`;

export default SwitchInput;
